import {useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import WelcomeSelector from '../../../../../selectors/modals/welcome_bonus';

import Slides from './slides';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import 'swiper/css';

export default ({scale}) => {
    const {available} = useSelector(WelcomeSelector),
          [sliderClass, setSliderClass] = useState("");

    // const list = ['bonus-zone', 'tournament', 'facebook', 'methods', 'wheel', 'testyourluck', 'vip', 'invite'];
    const list = ['facebook', 'tournament', 'bonus-zone', 'methods', 'wheel', 'testyourluck', 'vip', 'invite'];

    if(typeof window.slides === 'undefined')
        // window.slides = list.sort((a,b) => Math.random() - 0.5);
        window.slides = list;

    return (
        // <div className={`slider ${sliderClass}`} style={{transform: `scale(${scale})`}} >
        <div className={`slider ${sliderClass}`}>
            <div className="slider-carousel">
                <Swiper 
                    modules={[Pagination, Autoplay]}
                    loop={true}
                    pagination={{
                        el: '.pagination',
                        clickable: true,
                        renderBullet: (index, className) => {
                            return `<div class="dot ${className}" data-index="${index}"></div>`
                        }
                    }}
                    // autoplay={{
                    //     delay: 5e3
                    // }}
                    centeredSlides={true}
                    noSwiping={true}
                    speed={1e3}
                    slidesPerGroup={1}
                    slidesPerView={1}
                    onSlideChangeTransitionStart={(swiper) => {
                        const activeSlide = swiper.slides[swiper.activeIndex];
                        setSliderClass(activeSlide.getAttribute('data-type') || "");
                    }}
                    onInit={(swiper) => {
                        const activeSlide = swiper.slides[swiper.activeIndex];
                        setSliderClass(activeSlide.getAttribute('data-type') || "");
                    }}>
                    {available && <SwiperSlide data-type="welcome"><Slides.WelcomeBonus /></SwiperSlide>}
                    {window.slides.map((slide, key) => {
                        // if(slide === 'tournament') return <SwiperSlide data-type="tournament"><Slides.Tournament /></SwiperSlide>;
                        if(slide === 'tournament') return <SwiperSlide data-type="tournament"><Slides.NEW_SLIDES20.Tournament /></SwiperSlide>;
                        if(slide === 'methods') return <SwiperSlide data-type="methods"><Slides.NEW_SLIDES20.Deposit /></SwiperSlide>;
                        if(slide === 'wheel') return <SwiperSlide data-type="wheel"><Slides.NEW_SLIDES20.Wheel /></SwiperSlide>;
                        if(slide === 'testyourluck') return <SwiperSlide data-type="testyourluck"><Slides.NEW_SLIDES20.TestYourLuck /></SwiperSlide>;
                        if(slide === 'facebook') return <SwiperSlide data-type="facebook"><Slides.NEW_SLIDES20.Social /></SwiperSlide>;
                        // if(slide === 'facebook') return <SwiperSlide data-type="facebook"><Slides.Facebook /></SwiperSlide>;
                        if(slide === 'vip') return <SwiperSlide data-type="vip"><Slides.NEW_SLIDES20.VIP /></SwiperSlide>;
                        if(slide === 'invite') return <SwiperSlide data-type="invite"><Slides.NEW_SLIDES20.Referral /></SwiperSlide>;
                        if(slide === 'bonus-zone') return <SwiperSlide data-type="bonus-zone"><Slides.NEW_SLIDES20.BonusZone /></SwiperSlide>;
                    })}
                    {/* <SwiperSlide data-type="facebook"><Slides.Facebook /></SwiperSlide>
                    <SwiperSlide data-type="methods"><Slides.Methods /></SwiperSlide>
                    <SwiperSlide data-type="wheel"><Slides.Wheel /></SwiperSlide>
                    <SwiperSlide data-type="testyourluck"><Slides.TestYourLuck /></SwiperSlide>
                    <SwiperSlide data-type="facebook"><Slides.Facebook /></SwiperSlide>
                    <SwiperSlide data-type="vip"><Slides.VIP /></SwiperSlide>
                    <SwiperSlide data-type="invite"><Slides.Invite /></SwiperSlide> */}
                </Swiper>
            </div>
            <div className="pagination-space">
                <div className="pagination">
                    <div className="dot active"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
            </div> 
        </div>
    )
}